import { render, staticRenderFns } from "./CreateFeedbackRequest.vue?vue&type=template&id=6be4a238"
import script from "./CreateFeedbackRequest.vue?vue&type=script&lang=js"
export * from "./CreateFeedbackRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports